var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tag_black",
    "data-name": "Tag black",
    transform: "translate(-2992 -816)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 512,
    height: 512,
    transform: "translate(2992 816)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(3086 816)",
    fill: "#414040",
    stroke: "#292828",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 512,
    rx: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 314,
    height: 502,
    rx: 45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(3188.308 999.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M89.777,159.587a9.056,9.056,0,0,0-12.717,1.395,8.662,8.662,0,0,0-1.288,2.318c.061-.016.114-.045.177-.059a5.108,5.108,0,0,1,2.237,9.968c-.077.017-.152.014-.229.028.163.157.32.318.5.462a9.046,9.046,0,1,0,11.321-14.112Z",
    transform: "translate(-44.053 -105.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M135.14,159.587a9.057,9.057,0,0,0-12.718,1.395,8.687,8.687,0,0,0-1.288,2.318c.061-.016.115-.045.177-.059a5.108,5.108,0,0,1,2.237,9.968c-.076.017-.152.014-.229.028.163.157.32.318.5.462a9.046,9.046,0,1,0,11.321-14.112Z",
    transform: "translate(-50.136 -105.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M139.123,113.967a15.963,15.963,0,0,1,2.268-1.435c.426-.228.832-.419,1.232-.6a9.012,9.012,0,1,0-2.167-6.216q-.952.331-1.889.742a21.594,21.594,0,0,0-3.4,1.817,23.679,23.679,0,0,0-3.225,2.464,24.146,24.146,0,0,0-6.68,10.2,54.222,54.222,0,0,0-26.409-6.854h-.033a54.222,54.222,0,0,0-26.409,6.854,24.146,24.146,0,0,0-6.68-10.2,23.68,23.68,0,0,0-3.225-2.464,21.593,21.593,0,0,0-3.4-1.817q-.935-.412-1.889-.742a9.092,9.092,0,1,0-2.167,6.216c.4.179.806.371,1.232.6a16.011,16.011,0,0,1,2.268,1.435,16.731,16.731,0,0,1,2.187,1.945A17.671,17.671,0,0,1,65.3,125.66a54.389,54.389,0,0,0-21.017,42.956l13.242-2.03.655,2.03a23.369,23.369,0,0,0,40.652,2.427,23.369,23.369,0,0,0,40.652-2.427l.654-2.03,13.243,2.03a54.389,54.389,0,0,0-21.017-42.956,17.665,17.665,0,0,1,4.569-9.748A16.677,16.677,0,0,1,139.123,113.967ZM79.18,175.407A17.057,17.057,0,1,1,96.238,158.35,17.076,17.076,0,0,1,79.18,175.407Zm56.365-17.057a17.058,17.058,0,1,1-17.058-17.057A17.076,17.076,0,0,1,135.545,158.35Z",
    transform: "translate(-39.142 -97.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M104.944,250.318a54.048,54.048,0,0,1-20.274-3.961l20.258,15.124,20.251-15.11A54,54,0,0,1,104.944,250.318Z",
    transform: "translate(-45.246 -117.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M151.412,200.6a159.407,159.407,0,0,1-51.381,8.7,159.311,159.311,0,0,1-51.105-8.6,54.489,54.489,0,0,0,16.2,23.374c6.379,2.7,17.6,5.926,34.9,5.926,17.687,0,29.045-3.379,35.345-6.109A54.469,54.469,0,0,0,151.412,200.6Z",
    transform: "translate(-40.453 -110.933)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagBlack);
export default __webpack_public_path__ + "static/media/tag_black.cbcc85241c1c4b0a3ef4c2da510d0fb7.svg";
export { ForwardRef as ReactComponent };